import React from "react";
import Navbar from "../Home/NavBar/Navbar";
import EventDetail from "../Details/EventDetail/EventDetail";
import Footer from "../Home/Footer/Footer";
import { Container } from "@mui/material";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";


export default function MainDetailPage() {
  const location = useLocation();
const queryParams = new URLSearchParams(location.search);
const senderId = queryParams.get("sender");
  const { eventId } = useParams();

  return (
    <div>
      <Container
        style={{
          maxWidth: "1450px",
          paddingLeft: "25px",
          paddingRight: "25px",
        }}
        sx={{ justifyContent: "center", alignItems: "center" }} // align
      >
        <Navbar />
      </Container>
      <EventDetail paramId={eventId} senderId={senderId} />
      <Footer />
    </div>
  );
}
